import get from 'lodash/get';

import { setNewTokens } from '~/slices/auth';

import AuthService from './AuthService';
import HttpRestService from './HttpRestService';
import UserService from './UserService';
import S3Service from './S3';

let userService;
let authService;
let httpRestService;
let s3Service;

const initServices = (store) => {
    AuthService.getAccessToken =
        UserService.getAccessToken =
        S3Service.getAccessToken =
            () => get(store.getState(), 'auth.access_token');

    AuthService.getRefreshToken = () => get(store.getState(), 'auth.refresh_token');
    AuthService.refreshTokenCallback = (data) => store.dispatch(setNewTokens(data));

    httpRestService = new HttpRestService();
    authService = new AuthService(httpRestService);
    userService = new UserService(httpRestService);
    s3Service = new S3Service(httpRestService);
};

export { initServices, userService, authService, httpRestService, s3Service };
